import { useState } from "react";
import { EyeFilled, EyeInvisibleFilled } from "@ant-design/icons";

export const RegisterForm = ({
  username,
  password,
  isLoading,
  isError,
  setUsername,
  setPassword,
  handleSubmit,
}) => {
  const [isPasswordVisible, setIsPasswordVisible] = useState(false);

  return (
    <div className="row justify-content-center mx-auto w-100 px-2">
      <div className="col-12 col-sm-10 col-md-7 col-lg-5 col-xl-4">
        <form onSubmit={handleSubmit} method="POST">
          <div className="mb-3">
            <label htmlFor="username" className="form-label">
              Username
            </label>
            <input
              type="text"
              className="form-control"
              id="username"
              name="username"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              disabled={isLoading}
              autoComplete="off"
              required
            />
          </div>
          <div className="mb-3">
            <label htmlFor="password" className="form-label">
              Password
            </label>
            <div className="input-group">
              <input
                type={isPasswordVisible ? "text" : "password"}
                className="form-control"
                id="password"
                name="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                disabled={isLoading}
                autoComplete="off"
                required
              />
              <button
                type="button"
                className="d-flex align-items-center justify-content-center border border-0"
                onClick={() => setIsPasswordVisible((prev) => !prev)}
                disabled={isLoading}
                tabIndex={-1}
              >
                {isPasswordVisible ? <EyeInvisibleFilled /> : <EyeFilled />}
              </button>
            </div>
          </div>

          {isError && !isLoading && (
            <span className="text-danger">invalid Username or Password!</span>
          )}
          <button
            type="submit"
            disabled={isLoading}
            className="btn btn-primary w-100"
          >
            {isLoading ? (
              <div className="spinner-border spinner-border-sm" role="status">
                <span className="visually-hidden">Loading...</span>
              </div>
            ) : (
              "Submit"
            )}
          </button>
        </form>
      </div>
    </div>
  );
};
